<template>
  <create-dialog
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
    width="60%"
  >
    <template slot="form">
      <form>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4">
            <fg-input
              type="number"
              step="0.01"
              min="0"
              max="100"
              :label="`${$t('common_words.percentage')}: *`"
              v-model="model.percentage"
              name="common_words.percentage"
              v-validate="modelValidations.percentage"
              :error="getError('common_words.percentage', true)"
            ></fg-input>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label>{{ $t('common_words.starting_date') }}: *</label>
            <br />
            <el-date-picker
              :placeholder="`${$t('common_words.select2')}...`"
              class="shadow-sm required-start-date"
              v-model="model.start_date"
              value-format="yyyy-MM-dd"
            />
          </div>
          <select-component
            :rowClass="`col-12 col-md-12 col-lg-4`"
            :isMultiple="false"
            :dataOptions="businesses"
            :requireClass="`required-business-id`"
            @onChange="handleChangeSelected"
            :labelSelect="`${$t('common_words.company')}: *`"
            modelName="business_id"
            :initialSelection="model.business_id"
          />
        </div>
      </form>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create-quality-percentage',
  mixins: [MixinDialog, MixinForm, MixinLoading, MixinValidations],
  data() {
    return {
      disabledField: false,
      model: {
        percentage: null,
        start_date: null,
        business_id: null,
      },
      modelValidations: {
        percentage: {
          required: true,
          decimal: true,
          min_value: 1,
          max_value: 100,
        },
      },
      businesses: [],
    };
  },
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.business_id)) {
            return this.validationInputsRequired('business-id');
          } else if (!isset(this.model.start_date)) {
            return this.validationInputsRequired('start-date');
          } else {
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    handleChangeSelected(data) {
      this.$set(this.model, data.name, data.selects);
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model = {
        ...editForm,
        isEdit: true,
      };

      sessionStorage.removeItem('editForm');
    }
  },
  mounted() {
    this.showHideLoading(true);
    Axios.getMasters('businesses/only')
      .then((response) => {
        this.businesses = response.data.data;
        this.showHideLoading();
      })
      .catch((error) => {
        this.showMessageErrors(error);
        this.showHideLoading();
      });
  },
};
</script>
